import React, { Component } from "react";
import "./../pages/Calculators.css";
import { Stack } from "react-bootstrap";

interface IProps {
  id: string;
  label: any;
  value?: number;
  classes?: string;
  onChange(v: any): void;
  onBlur?(): void;
  type?: "currency" | "percentage";
}

interface IState {
  value?: number;
}

export class BooleanInput extends Component<IProps, IState> {
  /**
   *
   */
  constructor(props: IProps) {
    super(props);

    this.state = { value: props.value };
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (this.state.value != this.props.value) {
      this.setState({ value: this.props.value });
    }
  }
  percentFormatter(v: string): string {
    var value = parseFloat(v);
    if (isNaN(value) || value === 0) return "";
    return value.toLocaleString("en-US", { useGrouping: true }) + "%";
  }
  percentToNumber(v: string): string {
    var rawValue = this.replaceAll(v, ",", "");
    var value = parseFloat(rawValue.replace("%", ""));
    if (isNaN(value) || value === 0) return "";
    return value.toString();
  }
  replaceAll(v: string, find: string, replaceWith: string): string {
    if (v.includes(find)) {
      return this.replaceAll(v.replace(find, replaceWith), find, replaceWith);
    }
    return v;
  }
  currencyFormatter(v: string): string {
    var value = parseFloat(v);
    if (isNaN(value) || value === 0) return "";
    return "€ " + value.toLocaleString("en-US", { useGrouping: true });
  }
  currencyToNumber(v: string): string {
    var rawValue = this.replaceAll(v, ",", "");
    var value = parseFloat(rawValue.replace("€ ", ""));
    if (isNaN(value) || value === 0) return "";
    return value.toString();
  }

  getType(): "currency" | "percentage" {
    return this.props.type ?? "currency";
  }

  toFormat(v: string): string {
    if (this.getType() === "percentage") {
      return this.percentFormatter(v);
    }
    return this.currencyFormatter(v);
  }
  toValue(v: string): string {
    if (this.getType() === "percentage") {
      return this.percentToNumber(v);
    }
    return this.currencyToNumber(v);
  }

  getPlaceholder(): string {
    if (this.getType() === "percentage") {
      return "0%";
    }
    return "€ 0";
  }

  getPostfix(): string | undefined {
    if (this.getType() === "percentage") {
      return "%";
    }
    return undefined;
  }

  getPrefix(): string | undefined {
    if (this.getType() === "currency") {
      return "€";
    }
    return undefined;
  }

  render() {
    return (
      <div className="calc-grid justify-left">
        <Stack direction="horizontal" gap={4}>
          <div className="checkbox-input">
            <input
              id={this.props.id}
              key={this.props.id + "-input"}
              className={" " + (this.props.classes ?? "")}
              type="checkbox"
              //checked={!!this.props.value}
              onChange={(e) => {
                this.props.onChange(e);
                //this.setState({value: +numberValue})
              }}
            />
            <label htmlFor={this.props.id}></label>
          </div>
          <label className="calculator-labels mt-3">{this.props.label}</label>
        </Stack>
      </div>
    );
  }
}
